import { Box, Skeleton } from '@mui/material';

interface PageTabsSkeletonProps {
  count?: number;
}

/**
 * Renders a lightweight skeleton row used as a placeholder for page tabs.
 */
export function PageTabsSkeleton({ count = 6 }: PageTabsSkeletonProps) {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      columnGap={2}
      rowGap={1}
      minHeight="48px"
    >
      {Array.from({ length: count }, (_, index) => (
        <Skeleton key={index} variant="rounded" width={80} height={20} sx={{ borderRadius: 1 }} />
      ))}
    </Box>
  );
}
